/**
 * delete base res from api and keep this once we integrate BaseState
 **/
import { ErrorModel } from '../models/error';
import { DEFAULT_REQ_STATE, ReqState } from './base-state';
import { DEFAULT_PAGE_STATE, PageState } from './page-state';

//Validate error model def
export interface BaseRES<T = null> {
  data: T;
  errors: ErrorModel[] | null; //Review errors not required as reqState has all the info
  pageState: PageState | null;
  reqState: ReqState | null;
}

export const DEFAULT_BASE_RES = {
  data: null,
  errors: null,
  pageState: DEFAULT_PAGE_STATE,
  reqState: DEFAULT_REQ_STATE
};
